import CryptoJS from "crypto-js";

const identityValue = process.env.REACT_APP_IDENTITY_VALUE;

// Matches the project-wide aesDecrypt convention (see App.js/AppMobile.js):
// AES-128/CBC/Pkcs7 with a fixed IV (REACT_APP_IDENTITY_VALUE). The websocket
// "Key" field is SessionID + timestamp/UserAccountID metadata appended by the
// backend; only the first 16 characters are the actual AES-128 key bytes.
function tryDecryptWithShortKeyAndIv(encryptedData, key) {
  const parsedKey = CryptoJS.enc.Utf8.parse(key.slice(0, 16));
  const iv = CryptoJS.enc.Utf8.parse(identityValue);

  const decrypted = CryptoJS.AES.decrypt(encryptedData, parsedKey, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return decrypted.toString(CryptoJS.enc.Utf8);
}

function tryDecryptWithKeyAndIv(encryptedData, key) {
  const parsedKey = CryptoJS.enc.Utf8.parse(key);
  const options = {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  };

  if (identityValue) {
    options.iv = CryptoJS.enc.Utf8.parse(identityValue);
  }

  const decrypted = CryptoJS.AES.decrypt(encryptedData, parsedKey, options);
  return decrypted.toString(CryptoJS.enc.Utf8);
}

function tryDecryptWithPassphrase(encryptedData, key) {
  const decrypted = CryptoJS.AES.decrypt(encryptedData, key);
  return decrypted.toString(CryptoJS.enc.Utf8);
}

export function decryptCardDetailData(encryptedData, key) {
  const normalizedData = String(encryptedData || "").trim();
  const normalizedKey = String(key || "").trim();

  if (!normalizedData || !normalizedKey) {
    throw new Error("Missing card detail decrypt data.");
  }

  const attempts = [
    ["shortKeyAndIv", tryDecryptWithShortKeyAndIv],
    ["keyAndIv", tryDecryptWithKeyAndIv],
    ["passphrase", tryDecryptWithPassphrase],
  ];

  for (const [name, attempt] of attempts) {
    try {
      const result = attempt(normalizedData, normalizedKey);

      if (!result) {
        continue;
      }

      return result;
    } catch (error) {
    }
  }

  throw new Error("Unable to decrypt card detail data.");
}
